export const radioLables = [{label :"Top10" , value : "TOP10"} , {label :"All" , value : "ALL"}];

export const tabsList = [
    {
      tabName: "Part A Expense",
      key:"1",
      expenseType : "Part A"
    },
    {
      tabName: "Part B Expense",
      key:"2",
      expenseType : "Part B"
    },
    {
      tabName: "Part D Expense",
      key:"3",
      expenseType : "Part D"
    },
    {
      tabName: "Total Expense",
      key:"4",
      expenseType : "Total"
    }
  ]

export const ExpenseData = [
  { title: "Total Expense", displayCount: 'NA', count: Number("$ 0.00"?.split(" ")?.[1] || 0), displayText: null},
  { title: "Part A", displayCount: "NA", count: Number("$ 0.00"?.split(" ")?.[1] || 0), color: "#807AF4", displayText: null },
  { title: "Part B", displayCount: "NA", count: Number("$ 0.00"?.split(" ")?.[1] || 0), color: "#F1946F", displayText: null },
  { title: "Part D", displayCount: "NA", count: Number("$ 0.00"?.split(" ")?.[1] || 0), color: "#7DC7F8", displayText: null }
];